
import React from "react";
import QRCodeGenerator from "./QRCodeGenerator";
import "./QRCodeCard.css";
import MGButton from "../../components/MGButton/MGButton";

export default function QRCodeCard({
    qrValue,
    title,
    subtitle,
    logo,
    logoAlt = "Logótipo",
    qrSize = 152,
    onClick
}) {
    return (
        <div className="qr-card">
            <div className="qr-card__code">
                <QRCodeGenerator
                    value={qrValue}
                    size={qrSize}
                    title={title || "QR Code"}
                />
            </div>

            <div className="qr-card__content">
                {title && (
                    <p className="qr-card__title">
                        {title}
                    </p>
                )}

                {subtitle && (
                    <p className="qr-card__subtitle">
                        {subtitle}
                    </p>
                )}

                {logo && (
                    <img
                        className="qr-card__logo"
                        src={logo}
                        alt={logoAlt}
                    />
                )}
                <div className="qr-card__button">
                    <MGButton
                        type="secondary"
                        label="Voltar"
                        isEnable={true}
                        onClick={() => onClick()}
                    />
                </div>
            </div>
        </div>
    );
}
